var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"loadingContainer",staticStyle:{"background":"#fff"}},[_c('img',{staticStyle:{"width":"50%","height":"auto","position":"absolute","top":"0","bottom":"0","left":"0","right":"0","margin":"auto"},attrs:{"src":require("@/assets/initLoading.gif"),"alt":""}})])
}]

export { render, staticRenderFns }